
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";


// import { graph } from '@pnp/graph';
// import { escape, fromPairs } from '@microsoft/sp-lodash-subset';
 import { PIVOT_KEY } from '../common/consts';

import * as Fabric from 'office-ui-fabric-react';
// import { MSGraphClient } from '@microsoft/sp-http';
// import { WebPartContext } from "@microsoft/sp-webpart-base";
import  * as uuidv4 from "uuid/v4";
import { MessagesContainer } from '../message/MessagesContainer';
import { TextField } from "office-ui-fabric-react";
import { Link, initializeIcons, ActivityItem, Icon } from 'office-ui-fabric-react';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import log from 'loglevel';
import { getMessagesAndDispatch } from "../../model/messageService"
import { classNames, channelStyle} from "./Channel.Styles";


/**
 * 
 * @param param0 props params is assigned to variables
 * {
 * @param teamId 
 * @param channelId 
 * @param channel 
 * @param accessToken 
 * }
 */
export  function Channel({teamId, channelId, channel, accessToken}) {
    
    const { dispatch, state } = useContext(MessagesContext);
    const [isChecked, setIsChecked] = useState(false);
    const [showMessages, setShowMessages] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);

    log.info(`@Channel`);

    useEffect(() => {
      log.info(`useEffect @ Channel`);
      if ( isChecked ) 
      {
        try {          

          getMessagesAndDispatch(teamId, channelId,accessToken,dispatch);
          const ___payload = { pivotKey:  PIVOT_KEY.ITEMS};
          dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
          
      } catch (error) {
          log.error(`error / useEffect @ Channel: ${JSON.stringify(Error)}`);          
      } finally {
          log.info(`finally / useEffect @ Channel`);
      }

      }
      }, [isChecked]);

    const toggleShowMessages = ()=>{
          log.info(`toggleShowMessages @ Channel`);
          setShowMessages(!showMessages);
    };
  
    const handleToItemsM = ()=>{
      log.info(`handleToItemsM @ Channel`);
      setIsChecked(!isChecked); 
    }
   
      // Initialize icons in case this example uses them
      initializeIcons();

        
      const handleChannelWebUrl = ()=>{
       log.info(`handleChannelWebUrl @ Channel`); 
       window.open(channel.webUrl, '_blank')
      }

      const nextPage = () =>{
        log.info(`nextPage @ Channel`); 
        setPageNumber(pageNumber + 1);
      }  

      const previousPage = () =>{
        log.info(`previousPage @ Channel`); 
        const _pageNumber = pageNumber == 1 ? pageNumber : pageNumber -1;
        setPageNumber(_pageNumber);
      }  

      const _items= [
        {
          key: 'open',
          //text: 'Open channel in Teams',
          iconOnly: true,
          iconProps: { iconName: 'Communications' }
          // onClick: () => {
          //   handleChannelWebUrl();
          // }
        },
        {
          key: 'share',
          text: `[Channel:] ${channel.displayName}`,
         // onClick: () => {handleClick()}
        }
  
      ];
  
      const _farItems = [
        {
          key: 'toItemsM',
          text: 'Copy Messages to Items',
          iconOnly: true,
          iconProps: { iconName: 'Copy' },
          onClick:  ()=>{ handleToItemsM(); } 
        },
        {
          key: 'previousPage',
          text: 'Previous Page',
          iconOnly: true,
          iconProps: { iconName: 'ChevronLeftMed' },
          onClick:  ()=>{ previousPage() } 
        },
        {
          key: 'showMessages',
          text: `Messages: P-${pageNumber}`,
          onClick:  ()=>{ toggleShowMessages(); } 
        },{
          key: 'nextPage',
          text: 'Next Page',
          iconOnly: true,
          iconProps: { iconName: 'ChevronRightMed' },
          onClick:  ()=>{ nextPage(); } 
        }    
      ];
  
      const renderChannelBar=()=>{
        log.info(`renderChannelBar @ Channel`); 
        return (
                <div style={channelStyle()} >
                
                <CommandBar
                        items={_items}
                        farItems={_farItems}
                      />
                </div>
                );  
      };

      const renderMessages = () => {
        log.info(`renderMessages @ Channel`); 
        return (
                showMessages ?  <MessagesContainer 
                             teamId =  { teamId }
                             channelId = { channelId } 
                             accessToken = { accessToken }
                             pageNumber = { pageNumber }
                       /> : ''
               )       
       }
    return ( 
      <>
        {renderChannelBar()}
        {renderMessages()}
      </>
    );
  }
  




  // <li key={create_UUID()}>
//               <a href={message.webUrl}>{message.content.substr(0,50)} </a>
//             </li>


//    const context = this.props.context;
//const graphClient = await context.msGraphClientFactory.getClient();
//const appsResponse = await graphClient.api('appCatalogs/teamsApps').version('v1.0').get();
//const _context = this.context;

  //-------------------------

// const getMessagesMe = async (teamId, channelId, context) =>{
//     console.log(`@getMessages >  teamId - ${teamId} , channelId - ${channelId}`);
//     context.msGraphClientFactory
//     .getClient()
//     .then((client: MSGraphClient)=> {
//             client
//             .api('/me')
//             .get((error, user, rawResponse) => {
//                 console.log('@getMessages >  user ' + JSON.stringify(user));
//                 return [{}];
//                 }
//             );
  
//                         //console.log('msGraphClient: ' + JSON.stringify(msGraphClient))  
                                
                                
//                                 // const _me =  await msGraphClient.api('/me').get();
//                                 // const _meValue = _me.value
//                                 // console.log ('me: ' + JSON.stringify(_me));
//                                 // return _meValue; //_messages;
//             }
//     )};



// //------------------------





    // React.useEffect(() => {
    //     if (true) {
    //       console.log(`@Channel > useEffect :   teamId - ${teamId} , channelId - ${channelId}`);
    //        // getMessages(teamId, channelId, context).then((msg) =>{
    //     });        
    //   }
    //   else
    //        // setMessagesList([]);
    // }, [showMessages]);
  
/**
 * const getMessages
 * Gets the mesages based on @microsoft/sp-http client
 * @param teamId 
 * @param channelId 
 * @param msGraphClient 
 */
    // const getMessages = async (teamId, channelId, context) =>{
    //     console.log(`@getMessages >  teamId - ${teamId} , channelId - ${channelId}`);
    //     const messagesUrl = `/teams/${teamId}/channels/${channelId}/messages`; //MESSAGES_URL;
         
    //     context.msGraphClientFactory
    //     .getClient()
    //     .then((client: MSGraphClient)=> {
    //             client
    //             .api(messagesUrl)
    //             .headers({
    //               "Content-Type" : "application/json;charset=UTF-8",
    //                "mode": "cors",
    //               "Access-Control-Allow-Origin" : '' 
    //             })
    //             .version('beta')
    //             .get((error, messages, rawResponse) => {
    
    //               console.log('@getMessages >  selectedMessages ' + JSON.stringify(messages)); 
                    
    //                 if (messages) {
                      
    //                 let someMessages = [...messages.value];
    //                 if (messages.value.length > 2){
    //                     someMessages = [messages.value[0],messages.value[1],messages.value[2]];
    //                 }       
    
    
    //                 //const  selectedMessages =   someMessages.value.map(message => {
    //                     const  selectedMessages =   someMessages.map(message => {
    //                     const _message = 
    //                     {
    //                        id :  message.id,
    //                        content : message.body.content,
    //                        webUrl : message.webUrl,
    //                        user : message.from.user.displayName
    //                     };
                        
    //                     return _message;
    //                 });
    //                 console.log('@getMessages >  selectedMessages ' + JSON.stringify(selectedMessages));
            
    //                 setMessagesList(selectedMessages); 
    //                 return selectedMessages;
    
    //                 } else {
    //                     return [];
    //                 }
    
    //                 }
    //             );
    //             }
    //     )};
    //-------------------

              {/* <TextField
            key={uuidv4()}
            value={`[Channel:] ${channelDisplayName}`}
            readOnly
            resizable={false}  
            onClick={ (event)=>{ 
                if (event.ctrlKey ) {
                  handleCtrlKey()  
                } else {
                  toggleShowMessages()
                }
              }
            }

            style={channelStyle()}
          /> */}
    //-------------------

      // const activityItemExamples = [
      //   {
      //     key: 1,
      //     activityDescription: [
      //       <span key={1}>{`[Channel:] ${channel.displayName}`} </span>,
      //       <Link
      //         key={1}
      //         className={classNames.nameText}
      //         href={channel.webUrl}
      //       > 
      //          <Icon iconName={''} />
      //          <Icon iconName={'Message'} /> Teams
      //       </Link>,
      //       <Link
      //       key={2}
      //       className={classNames.nameText}
      //       onClick={() => {
      //         toggleShowMessages();
      //       }}
      //     > 
      //        <Icon iconName={''} />
      //        <Icon iconName={'Message'} /> Messages
      //     </Link>,
  
      //       <Link
      //         key={3}
      //         className={classNames.nameText}
      //         onClick={() => {
      //           handleCtrlKey();
      //         }}
      //       >
      //         <Icon iconName={''} /> 
      //         <Icon iconName={'Message'} /> Items[T]
      //       </Link>
    
      //     ],
      //     activityIcon: <Icon iconName={'Message'} />
      //   }
      // ];
